<!--
 * @Description: 新油卡协议显示
 * @Author: shiao
 * @Date: 2022-02-22 14:33:45
 * @LastEditors: shiao
 * @LastEditTime: 2022-06-24 10:51:26
-->
<template>
  <div class="partner-description-body">
    <div class="partner-description-nav">
      <navbar navbackgroundcolor="#FFFFFF" :lefticonshow="true" :title="title" titlecolor="#1B1A2E" @goback="goback" :lefticonwidth="9" :lefticonheight='16' :lefticon="newoilcardbackicon" />
    </div>
    <div class="description-content" v-html="agreementContent"></div>
  </div>
</template>

<script>
  import navbar from './components/nav-bar';
  import { getAgreementDetails } from './api/index.js';
  export default {
    components: {
      navbar,
    },
    data () {
      return {
        newoilcardbackicon: require('@/assets/recharge/new-oilcard-back-icon.png'),
        number: 'xbykxy  ',
        agreementContent: '', //协议信息
        title: ''
      }
    },
    created () {
      if (this.$route.query.number) {
        this.number = this.$route.query.number
        this.title = this.$route.query.title
      }
      this.getAgreement()
    },
    methods: {
      getAgreement () {
        //获取代理人协议信息
        getAgreementDetails({ number: this.number }).then(res => {
          this.agreementContent = res.content
          this.title = res.title
        })
      },
      // 返回
      goback () {
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="less" scoped>
  .partner-description-body {
    background-color: #F5F5F5;
    min-height: 100vh;
    overflow: hidden;

    .partner-description-nav {
      position: fixed;
      top: 0;
      padding-top: 44px;
      z-index: 2;
      background-color: #F5F5F5;
    }

    .description-content {
      padding: 22px 16px;
      background-color: #fff;
      margin-top: 88px;
      min-height: calc(100vh - 132px);
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1B1A2E;
      line-height: 22px;
    }
  }
</style>